import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f107148a&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=f107148a&prod&lang=scss&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=f107148a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f107148a",
  null
  
)

export default component.exports